module.exports = __webpack_public_path__ + "img/graph-pink.a6a8bb39.svg";